import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { AutoComplete, Input } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import {
  LDS_AUTOCMPLETE_CITIES,
  LDS_AUTOCOMPLETE_MORE,
} from "../../../../../assets/Data/LdsAirportsAutocomplete";
import {
  DYNAMIC_PACKAGES,
  useSearch,
} from "../../../../../contexts/SearchContext";

export const parseLocationToString = (l) =>
  l.AIRPORTCODE === ""
    ? `${l.COUNTRYNAME_HEB}`
    : `(${l.AIRPORTCODE}) ${l.COUNTRYNAME_HEB} - ${l.CITYNAME_HEB}`;

const AutoCompleteInput = ({
  saveLocationSelection,
  location = "",
  isOrigin,
}) => {
  const { categories, destinations, searchTab } = useSearch();
  const [currentValue, setCurrentValue] = useState(
    location ? parseLocationToString(location) : ""
  );
  const [cities, setCities] = useState([]);
  const { t } = useTranslation();
  const inputRef = useRef();

  useEffect(() => {
    setCurrentValue(location ? parseLocationToString(location) : "");
  }, [location]);

  useEffect(() => {
    const st = searchTab === DYNAMIC_PACKAGES ? "Flights" : searchTab;
    const cities = destinations
      .filter(
        (dest) =>
          dest.dealType === st &&
          (categories.length === 0 ||
            (categories.includes("ALL") &&
              (dest.subject === "ALL" || !dest.subject)) ||
            categories.includes(dest.subject))
      )
      .map((city) => {
        const hebCity = LDS_AUTOCMPLETE_CITIES.find(
          (ldsCity) => ldsCity.AIRPORTCODE === city.destCity
        );
        return {
          COUNTRYNAME_HEB: hebCity?.COUNTRYNAME_HEB || city.destCountryName,
          CITYNAME_HEB: hebCity?.CITYNAME_HEB || city.destCountryName,
          AIRPORTCODE: city.destCity,
          AIRPORTNAME: hebCity?.AIRPORTNAME || "",
          CITYCODE: city.destCity,
          CITYNAME: city.destCityName,
          COUNTRYCODE: hebCity?.COUNTRYCODE || "",
          COUNTRYNAME: city.destCountryName,
        };
      });

    const hebCities = cities.reduce((acc, city) => {
      if (!acc.find((c) => c.CITYCODE === city.CITYCODE)) {
        acc.push(city);
      }
      return acc;
    }, []);

    if (searchTab !== DYNAMIC_PACKAGES)
      for (let i = 0; i < LDS_AUTOCOMPLETE_MORE.length; i++)
        hebCities.unshift(LDS_AUTOCOMPLETE_MORE[i]);

    setCities(hebCities);
  }, [searchTab, categories, destinations]);

  // Ant Design expects options as [{ value, label, ... }]
  const getAntdOptions = () =>
    cities
      .filter((city) =>
        Object.values(city).some((value) =>
          value
            ? value
                .toString()
                .toLowerCase()
                .includes(currentValue.toLowerCase())
            : false
        )
      )
      .map((option) => {
        let label;
        if (option.CITYCODE === "ALL") {
          label = (
            <div className="autoComplete-input-option-row">
              <div>{`${option.COUNTRYNAME_HEB} - ${option.COUNTRYNAME}`}</div>
            </div>
          );
        } else {
          label = (
            <div className="autoComplete-input-option-row">
              {option?.COUNTRYNAME_HEB && option?.CITYNAME_HEB ? (
                <div>
                  {`(${option.AIRPORTCODE}) ${option.COUNTRYNAME_HEB} - ${option.CITYNAME_HEB}`}
                </div>
              ) : null}
              <div>{`${option.CITYNAME} - ${option.COUNTRYNAME}`}</div>
            </div>
          );
        }
        return {
          value: parseLocationToString(option),
          label,
          optionData: option,
        };
      });

  return (
    <div className="autoComplete-input-box-wrapper">
      <AutoComplete
        options={getAntdOptions()}
        value={currentValue}
        style={{ width: "100%" }}
        allowClear
        onChange={(value, option) => {
          setCurrentValue(value);
          // If user selects from dropdown, option will be defined
          if (option && option.optionData) {
            saveLocationSelection(option.optionData);
          }
        }}
        onSelect={(value, option) => {
          setCurrentValue(value);
          if (option && option.optionData) {
            saveLocationSelection(option.optionData);
          }
        }}
        filterOption={false} // Already filtered in getAntdOptions
        dropdownMatchSelectWidth={false}
        autoClearSearchValue={false}
      >
        <Input
          ref={inputRef}
          className="autoComplete-input-box"
          placeholder={
            !isOrigin
              ? t("hotelsearchbar.selectdestination")
              : t("hotelsearchbar.selectorigin")
          }
          prefix={<EnvironmentOutlined style={{ color: "#bfbfbf" }} />}
        />
      </AutoComplete>
    </div>
  );
};

export default AutoCompleteInput;
